import Base from './base'
import Request from '@utils/request'
import { toQueryString } from '@utils'

class Comment extends Base {
  async getComments(params) {
    const query = toQueryString(params)
    const response = await Request.get('/api/comments?' + query)
    return response
  }

  async create(data) {
    const response = await Request.post('/api/comments', data)
    return response
  }
}

export default new Comment()
